import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ActivityComments from './activity-comments';
import ActivityCommentsDetail from './activity-comments-detail';
import ActivityCommentsUpdate from './activity-comments-update';
import ActivityCommentsDeleteDialog from './activity-comments-delete-dialog';

const ActivityCommentsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ActivityComments />} />
    <Route path="new" element={<ActivityCommentsUpdate />} />
    <Route path=":id">
      <Route index element={<ActivityCommentsDetail />} />
      <Route path="edit" element={<ActivityCommentsUpdate />} />
      <Route path="delete" element={<ActivityCommentsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ActivityCommentsRoutes;
